'use strict';

function pageEngagement(g) {
  var $el = $('.parallax-img-left img, .parallax-img-right img');
  var controller = null;
  var scene = [];

  function init() {
    $(window).resize(resize);
    resize();
  }

  function reset() {
    if (controller != null) {
      controller.destroy(true);
      controller = null;
    }
    $el.attr('style', '');
  }

  function resize() {
    if ($(window).outerWidth() >= 1024) {
      reset();

      controller = new ScrollMagic.Controller();

      $el.each(function(id) {
        var tween = new TimelineMax();
        var offsetX = 0;
        var offsetY;
        var isImgLeft = $(this).parent().hasClass('parallax-img-left');
        var isImgRight = $(this).parent().hasClass('parallax-img-right');
        // console.log('isImgLeft : '+isImgLeft);
        // console.log('isImgRight : '+isImgRight);

        if (id % 2 == 0) {
          offsetY = 100;
        } else {
          offsetY = 250;
        }

        if ($(window).outerWidth() < 1200) {
          offsetX = isImgLeft ? '-100%' : '100%';
        } else if ($(window).outerWidth() < 1466) {
          offsetX = isImgLeft ? '-50%' : '50%';
        }
        // console.log('offsetX : '+offsetX);

        tween.add([TweenMax.fromTo($el[id], 1, {x: offsetX, y: offsetY}, {y: -1 * offsetY, ease: Linear.easeNone})]);

        scene[id] = new ScrollMagic.Scene({duration: $(window).height()})
            .setTween(tween)
            .triggerElement($('.entry-content')[0])
        // .addIndicators({name: 'Image ' + (id+1).toString()})
            .addTo(controller);
      });
    } else {
      reset();
    }
  }

  init();
}
